export default __webpack_public_path__ + "static/media/cooking_2020_OV_seemore_NN-CS89LB_Asia_01_201023-nz.c4628db2.jpg";